export default "__VITE_PUBLIC_ASSET__cd0394c8__"